import { AddressReqObj } from '@dehaat/kisan-app-bl/models/Address'

import { Address } from '@/models/Address'

import { post } from '../axios'

export const addNewAddressV3 = async (
  address: AddressReqObj,
): Promise<Address | null> => {
  try {
    return await post(`hyperlocal/v3/address`, {
      ...address,
    })
  } catch (e) {
    console.error(e)
    return null
  }
}
